<template>
  <v-card :width="width" class="mx-auto" outlined elevation="1">
    <slot name="content"></slot>
  </v-card>
</template>

<script>
export default {
  name: "wapi-card",
  props: {
    value: Array,
    title: {
      type: String,
      default: ""
    },
    width: Number
  },
  data() {
    return {
      showOptions: true
    };
  }
};
</script>